<template>
	<v-card>
		<v-card-text v-if="data.length > 0" class="pt-3">
			<p>Usuarios que comparto</p>
			<span v-for="(email, i) in data" :key="i">
				<v-chip
					small
					label
					class="ma-2"
					color="primary"
					text-color="white"
					close
					close-icon="mdi-close"
					@click:close="close(email)"
				>
					<span>{{ email }}</span>
				</v-chip>
			</span>
		</v-card-text>
		<v-card-text v-if="withme.length > 0" class="pt-3">
			<p>Usuarios compartidos conmigo</p>
			<span v-for="(email, i) in withme" :key="i">
				<v-chip
					small
					label
					class="ma-2"
					color="info"
					text-color="white"
					close
					close-icon="mdi-close"
					@click:close="closeWithMe(email)"
				>
					<span>{{ email }}</span>
				</v-chip>
			</span>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'UserSharingChips',
	props: {
		withme: { type: Array, required: true },
		data: { type: Array, required: true },
	},
	methods: {
		async closeWithMe(userEmail) {
			await this.removeShareWithMeUser({ userEmail });
		},
		async close(email) {
			await this.removeShareWithUser({ email });
		},
		...mapActions({
			removeShareWithMeUser: 'User/removeShareWithMeUser',
			removeShareWithUser: 'User/removeShareWithUser',
		}),
	},
};
</script>

<style scoped></style>
